export default __webpack_public_path__ + "static/media/colombialogo.3d8ecfc3.png";